import { create } from 'zustand'
import { getActiveAcademicYearId, getCurrentAcademicSession, type AcademicSessionDto } from '../api/academicYear'

interface AcademicYearState {
  academicYearId: string
  academicYearName: string
  currentSession: AcademicSessionDto | null
  setAcademicYear: (id: string, name?: string) => void
  getAcademicYearId: () => string
  fetchActiveAcademicYear: () => Promise<string>
  fetchCurrentAcademicSession: () => Promise<AcademicSessionDto | null>
}

export const useAcademicYearStore = create<AcademicYearState>((set, get) => ({
  academicYearId:
    (typeof window !== 'undefined'
      ? localStorage.getItem('academic_year_id') ||
        localStorage.getItem('academic_session_id') ||
        localStorage.getItem('x_academic_year')
      : '') || '',
  academicYearName:
    (typeof window !== 'undefined' ? localStorage.getItem('academic_year_name') || '2026-2027' : '2026-2027'),
  currentSession: null,

  setAcademicYear: (id: string, name?: string) => {
    if (typeof window !== 'undefined' && id) {
      localStorage.setItem('academic_year_id', id)
      localStorage.setItem('academic_session_id', id)
      localStorage.setItem('x_academic_year', id)
      if (name) localStorage.setItem('academic_year_name', name)
    }
    set({ academicYearId: id, academicYearName: name || get().academicYearName })
  },

  getAcademicYearId: () => {
    const current = get().academicYearId
    if (current) return current
    if (typeof window !== 'undefined') {
      const stored =
        localStorage.getItem('academic_year_id') ||
        localStorage.getItem('academic_session_id') ||
        localStorage.getItem('x_academic_year')
      if (stored) return stored
    }
    return ''
  },

  fetchActiveAcademicYear: async () => {
    try {
      const session = await getCurrentAcademicSession()
      if (session?.id) {
        set({
          academicYearId: session.id,
          academicYearName: session.academicYearName || get().academicYearName,
          currentSession: session,
        })
        return session.id
      }
      const id = await getActiveAcademicYearId()
      if (id) {
        set({ academicYearId: id })
        return id
      }
    } catch {
      // ignore error
    }
    return get().getAcademicYearId()
  },

  fetchCurrentAcademicSession: async () => {
    try {
      const session = await getCurrentAcademicSession()
      if (session) {
        set({
          academicYearId: session.id || get().academicYearId,
          academicYearName: session.academicYearName || get().academicYearName,
          currentSession: session,
        })
        return session
      }
    } catch {
      // ignore error
    }
    return get().currentSession
  },
}))

